import { push } from 'react-router-redux';

import types from './types';
import { store } from '../store';

const login = (email, password) => ({
  API_CALL: {
    requestType: types.LOGIN_REQUEST,
    successType: types.LOGIN_SUCCESS,
    failureType: types.LOGIN_FAILURE,
    endpoint: 'login',
    params: { email, password },
    onSuccess: () => store.dispatch(push('/')),
  },
});

const getPasswordToken = email => ({
  API_CALL: {
    requestType: types.LOGIN_REQUEST,
    successType: types.LOGIN_SUCCESS,
    failureType: types.LOGIN_FAILURE,
    endpoint: 'users/password',
    params: { email },
  },
});

const updatePassword = (password, token) => ({
  API_CALL: {
    requestType: types.LOGIN_REQUEST,
    successType: types.LOGIN_SUCCESS,
    failureType: types.LOGIN_FAILURE,
    httpMethod: 'PUT',
    endpoint: 'users/password',
    params: { password, token },
  },
});

const logout = () => ({
  type: types.LOGOUT,
});

const fetchCurrentUser = () => ({
  API_CALL: {
    requestType: types.FETCH_CURRENT_USER_REQUEST,
    successType: types.FETCH_CURRENT_USER_SUCCESS,
    failureType: types.FETCH_CURRENT_USER_FAILURE,
    httpMethod: 'GET',
    endpoint: 'verify_token',
  },
});


export default {
  login,
  logout,
  getPasswordToken,
  updatePassword,
  fetchCurrentUser,
};

// import { push } from 'react-router-redux';

// import types from './types';
// import { store } from '../store';
// import { stopImpersonation } from 'utils/impersonation';

// const login = (email, password) => ({
//   API_CALL: {
//     requestType: types.LOGIN_REQUEST,
//     successType: types.LOGIN_SUCCESS,
//     failureType: types.LOGIN_FAILURE,
//     endpoint: 'login',
//     params: { email, password },
//     onSuccess: () => {
//       store.dispatch(fetchCurrentUser());
//       store.dispatch(push('/'));
//     },
//   },
// });

// const getPasswordToken = email => ({
//   API_CALL: {
//     requestType: types.LOGIN_REQUEST,
//     successType: types.LOGIN_SUCCESS,
//     failureType: types.LOGIN_FAILURE,
//     endpoint: 'users/password',
//     params: { email },
//   },
// });

// const fetchCurrentUser = () => ({
//   API_CALL: {
//     requestType: types.FETCH_CURRENT_USER_REQUEST,
//     successType: types.FETCH_CURRENT_USER_SUCCESS,
//     failureType: types.FETCH_CURRENT_USER_FAILURE,
//     httpMethod: 'GET',
//     endpoint: 'current_user',
//   },
// });

// const updatePassword = (password, token) => ({
//   API_CALL: {
//     requestType: types.LOGIN_REQUEST,
//     successType: types.LOGIN_SUCCESS,
//     failureType: types.LOGIN_FAILURE,
//     httpMethod: 'PUT',
//     endpoint: 'users/password',
//     params: { password, token },
//   },
// });

// const logout = () => {
//   stopImpersonation();
//   return {
//     type: types.LOGOUT,
//   };
// };

// export default {
//   login,
//   logout,
//   getPasswordToken,
//   updatePassword,
//   fetchCurrentUser,
// };
